import { UploadOutlined } from '@ant-design/icons';
import { Button, message, Modal, Spin, Table, Upload } from 'antd';
import { hanhtrangsoClient } from 'configs/api';
import { generateSHA1 } from 'helpers/CryptoHelper';
import { sendEmailV2 } from 'helpers/MailHelper';
import { query } from 'helpers/QueryHelper';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { ExcelRenderer } from 'react-excel-renderer';
import { CURRENT_DOMAIN, IS_SACHSO } from 'constants/settings';
import { removeSpacesAndAccents_toUpperCase } from 'utils/convertValue';
import { isEmail } from 'utils/validateValue';
import columns from './columns';
import { checkExistsEmail } from 'modules/Administration/components/Users/api/user_api';

const ExcelRegister = ({ isOpen, onRefeshData }) => {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isDisableSaveBtn, setIsDisableSaveBtn] = useState(false);

  const tableKey = useMemo(() => {
    if (rows && rows?.length > 0) {
      const stringArr = rows.map((i) => i.message);
      return stringArr.toString();
    } else {
      return 'table-import-excel-users';
    }
  }, [rows]);

  //nhận lệnh bật/ tắt modal từ bên ngoài
  useEffect(() => {
    if (isOpen) {
      setIsOpenModal(true);
      setIsDisableSaveBtn(true);
      setRows(null);
    } else {
      onCloseModal();
    }
  }, [isOpen]);

  const onCloseModal = () => {
    setIsOpenModal(false);
  };

  const checkRowData = (data) => {
    const newData = { ...data };
    const { fullname, lastname, firstname, gender, email, password, confirmPassword, schoolTypeId, birthday, userType, parentFullname } = data;

    if (!email) {
      newData.status = 0;
      newData.message = 'Chưa nhập email';
    } else if (!isEmail(String(email))) {
      newData.status = 0;
      newData.message = 'Email không đúng định dạng';
    } else if (!fullname) {
      newData.status = 0;
      newData.message = 'Chưa nhập tên người dùng';
    } else if (!schoolTypeId) {
      newData.status = 0;
      newData.message = 'Chưa nhập cấp học';
    } else if (!userType) {
      newData.status = 0;
      newData.message = 'Chưa nhập loại tài khoản';
    }

    return newData;
  };

  const getRowsData = async (data) => {
    let countRows = 0;
    const filterData = data.filter((row, index) => {
      if (!!(row && row?.length > 0 && countRows < 1000)) {
        countRows += 1;
        return true;
      } else {
        return false;
      }
    });
    const newData = await filterData.map((row, index) => {
      const fullname = row[1]?.replaceAll('  ', ' ')?.trim();
      const email = row[2]?.trim();
      const fullnameArray = fullname?.split(/[\s,]+/);
      const password = row[3] ? row[3] : 'sachso';
      const gender = removeSpacesAndAccents_toUpperCase(String(row[4])) === 'NU' ? 2 : 1;
      const birthday = String(row[5])?.split('-')?.length === 3 ? String(row[5]) : '1990-01-01';
      const schoolTypeId = [1, 2, 3, '1', '2', '3'].includes(row[7]) ? Number(row[7]) : 1;
      const userType = String(row[8]) === 'GV' ? 2 : 1;
      const schoolType = schoolTypeId == 1 ? 'Tiểu học' : schoolTypeId == 2 ? 'Trung học cơ sở' : schoolTypeId == 3 ? 'Trung học phổ thông' : '';

      const rowData = {
        // Hiển thị giao diện.
        no: index + 1,
        fullname,
        email,
        schoolTypeId,
        schoolType,
        type: userType === 1 ? 'Học sinh' : 'Giáo viên',
        // Gửi api.
        firstname: _.last(fullnameArray),
        lastname: _.dropRight(fullnameArray).join(' '),
        gender: gender,
        password: password,
        confirmPassword: password,
        birthday,
        parentFullname: '',
        userType: userType,
        //biến check
        status: 9, // 0 - lỗi, 1-thêm mới , 2 - update
        message: '',
        mailStatus: 9,
        mailMessage: 'Chưa gửi',
      };
      const checkedData = checkRowData(rowData);
      return checkedData;
    });
    return newData;
  };

  const fileHandler = (fileList) => {
    setRows(null);
    const fileObj = fileList;
    if (!fileObj) {
      message.error('Không có tệp nào được tải lên!');
      return false;
    }
    if (!(fileObj.type === 'application/vnd.ms-excel' || fileObj.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      message.error('Định dạng tập tin không xác định. Chỉ các tệp Excel được tải lên!');
      return false;
    }
    // just pass the fileObj as parameter
    ExcelRenderer(fileObj, async (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        await setLoading(true);
        const newRows = await getRowsData(resp.rows.slice(1));

        if (newRows.length === 0) {
          message.error('Không có dữ liệu nào được tìm thấy trong tệp!');
          return false;
        }
        //Check exist email
        const promises = newRows.map((row) => {
          return new Promise((resolve, reject) => {
            if (row.status === 0) {
              reject(row);
            } else {
              checkExistsEmail(row.email)
                .then((res) => {
                  reject({
                    ...row,
                    status: 2,
                    message: 'Email đã tồn tại',
                  });
                })
                .catch((err) => {
                  //Email chua dang ky
                  resolve({
                    ...row,
                    status: 1,
                    message: 'Thêm mới',
                  });
                });
            }
          });
        });
        Promise.allSettled(promises).then((results) => {
          //Thành công thì trả về {status : 'fulfilled' , value: giá trị trả về của resolve()}
          //Thất bại thì trả về {status : 'rejected' , reason: giá trị trả về của reject()}
          const resultValues = results.map((result) => result.value ?? result.reason);
          setIsDisableSaveBtn(false);
          setRows(resultValues);
          setLoading(false);
        });
      }
    });
    //Chặn hành động upload mặc định của <Upload/>
    return false;
  };

  const registerUser_hanhtrangso = (values) => {
    const body = {
      lastname: values.lastname,
      firstname: values.firstname,
      gender: values.gender,
      email: values.email,
      password: values.password,
      confirmPassword: values.confirmPassword,
      schoolTypeId: values.schoolTypeId,
      birthday: values.birthday,
      userType: values.userType,
      parentFullname: values.parentFullname,
    };
    hanhtrangsoClient.post('/Register', body);
  };

  const handleSendMail = (data) => {
    return new Promise((resolve, reject) => {
      const { email, password, userType, schoolTypeId, status } = data;
      let templateName = '';
      if (userType === 1) {
        // HỌC SINH
        if (schoolTypeId === 1) {
          // Tiểu học
          templateName = 'SachSo_SendEmailCapTH';
        } else if (schoolTypeId === 2) {
          //THCS
          templateName = 'SachSo_SendEmailCapTHCS';
        } else if (schoolTypeId === 3) {
          //THPT
        }
      } else if (userType === 2) {
        // GIÁO VIÊN
        if (status === 2) {
          templateName = 'SACHSO_SendEmail_ExistsAccount';
        } else if (status === 1) {
          templateName = 'SACHSO_SendEmail_RegisterAccount';
        }
      }
      if (templateName) {
        sendEmailV2(email, password, templateName)
          .then((response) => {
            resolve({
              mailStatus: 1,
              mailMessage: 'Thành công',
            });
          })
          .catch((err) => {
            reject({
              mailStatus: 0,
              mailMessage: 'Thất bại',
            });
          });
      } else {
        reject({
          mailStatus: 0,
          mailMessage: 'Chưa có mẫu mail',
        });
      }
    });
  };

  const handleSubmit = () => {
    if (!loading) {
      setLoading(true);
      const promises = rows.map(
        (row, index) =>
          new Promise(async (resolve, reject) => {
            const { lastname, firstname, gender, email, password, confirmPassword, schoolTypeId, birthday, userType, parentFullname, status } = row;
            if (status === 0) {
              return resolve('Dữ liệu không đạt yêu cầu nên không lưu!');
            }

            //Xử lý gửi mail với ác email đã có
            if (status === 2) {
              const result = await handleSendMail(row);
              (result.mailStatus === 1 ? resolve : reject)({
                ...row,
                ...result,
              });
              return;
            }

            //Tạo mới người dùng
            if (IS_SACHSO) {
              //Nếu là live thì mới gọi API đăng kí hanhtrangso
              registerUser_hanhtrangso(row);
            }

            const params = {
              email,
              password: generateSHA1(password),
              fullName: lastname.concat(' ', firstname),
              roleId: userType,
              schoolTypeId,
              cityId: 0,
              phone: '',
            };
            query('p_SACHSO_Users_Register', params)
              .then(async (res) => {
                const result = await handleSendMail(row);
                resolve({
                  ...row,
                  ...result,
                  status: 1,
                  errors: 'Thành công',
                });
              })
              .catch((err) => {
                resolve({
                  ...row,
                  status: 0,
                  errors: 'Thất bại',
                });
              });
          }),
      );
      Promise.allSettled(promises).then((results) => {
        //Thành công thì trả về {status : 'fulfilled' , value: giá trị trả về của resolve()}
        //Thất bại thì trả về {status : 'rejected' , reason: giá trị trả về của reject()}
        const resultValues = results.map((result) => result.value ?? result.reason);
        setIsDisableSaveBtn(true);
        setRows(resultValues);
        setLoading(false);
        onRefeshData?.();
      });
    }
  };

  return (
    <React.Fragment>
      <Modal
        visible={isOpenModal}
        title='NHẬP TỪ EXCEL'
        onCancel={() => onCloseModal()}
        footer={
          <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'end', columnGap: 10 }}>
            <Button
              onClick={() => {
                onCloseModal();
              }}
            >
              Đóng
            </Button>
            <Button disabled={rows && isDisableSaveBtn} loading={loading} onClick={() => handleSubmit()} type='primary'>
              Tạo người dùng
            </Button>
          </div>
        }
        centered
        width={1200}
        bodyStyle={{ paddingBottom: rows ? 0 : 24 }}
      >
        <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'start', columnGap: 10 }}>
          <Upload
            name='file'
            accept='.xlsx'
            beforeUpload={fileHandler}
            maxCount={1}
            onChange={(infor) => {
              if (!infor.fileList[0]) setRows(null);
            }}
          >
            <Button icon={<UploadOutlined />}>Click to Upload Excel File</Button>
          </Upload>
          <span style={{ fontSize: 14, textDecoration: 'none', color: 'blue', cursor: 'pointer', marginTop: 4 }}>
            <a href={CURRENT_DOMAIN + '/templates/excel/ImportUser_PhuongNam.xlsx'} download style={{ color: '#0078b7' }}>
              Tải tệp mẫu
            </a>
          </span>
        </div>
        <div>
          <i>Giới hạn mỗi lần tạo là 1000 tài khoản, mật khẩu mặc định là "sachso"</i>
        </div>
        <Spin spinning={loading} tip={rows ? 'Đang tạo tài khoản...' : 'Đang nhập dữ liệu từ excel'}>
          <div style={{ marginTop: 20 }}>
            <Table key={tableKey} rowKey='uid' dataSource={rows} columns={columns} scroll={{ y: 'calc(100vh - 360px)' }} bordered />
          </div>
        </Spin>
      </Modal>
    </React.Fragment>
  );
};

export default ExcelRegister;
